import { createSlice } from "@reduxjs/toolkit";
import { IFreshmanConfigurationSlice } from "../../../models/freshman/configuration";

const initialFreshmanConfiguration: IFreshmanConfigurationSlice = {
  freshmanConfiguration: undefined,
  freshmanConfigurations: undefined,
};

const freshmanConfigurationSlice = createSlice({
  name: "freshmanConfiguration",
  initialState: initialFreshmanConfiguration,
  reducers: {
    setConfigurations: (state, action: { payload: any }) => {
      state.freshmanConfigurations = action.payload;
    },
    setConfiguration: (state, action: { payload: any }) => {
      state.freshmanConfiguration = action.payload;
    },
  },
});

export const {setConfigurations , setConfiguration } = freshmanConfigurationSlice.actions;
const freshmanConfigurationReducers = freshmanConfigurationSlice.reducer;
export type freshmanCofigurationState = ReturnType< typeof freshmanConfigurationReducers>
export default freshmanConfigurationReducers;
